import { TextField } from "@kobalte/core";
import type { JSX } from "solid-js";
import { styled } from "solid-styled-components";

export const InputDefaultCss = `
  padding: 0 22px;
  border: none;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 76px;
  font-weight: 500;
  font-size: 14px;
  overflow: hidden;
  position: relative;
  border-radius: 15px;
  @media only screen and (max-width: 756px) {
    font-size: 15px;
  }
 
`;

export const InputBase = styled(TextField.Root)<{ w?: JSX.CSSProperties["width"] }>`
  display: flex;
  flex-direction: column;
  ${(props) => `
  width: ${props.w ?? "100%"};`}
`;

export const InputField = styled(TextField.Input)<{
	margin?: string;
	h?: JSX.CSSProperties["height"];
	invalid?: boolean;
	alternative?: boolean;
	disabled?: boolean;
	passwordType?: boolean;
	p?: JSX.CSSProperties["padding"];
	icon?: boolean;
}>`
  width: 100%;
  line-height: 0px;
  ${InputDefaultCss}
  ${(props) => `
    background: ${props.alternative ? props.theme?.colors.colorInvert : props.theme?.input?.background};
    height: ${props.h ? props.h : "50px"};
    input[type="date"]{
      line-height: ${props.h ?? "76px"};
    }
    color: ${props.theme?.input?.color};
    ${props.margin ? `margin: ${props.margin};` : ""}
    &:is([data-invalid]){
      border: 2px solid ${props.theme?.colors.error};
    }
    ${props.disabled ? "opacity: 0.6;cursor: not-allowed;" : ""}
    ${props.p ? `padding: ${props.p};` : ""}
    ${props.passwordType ? "padding-right:50px;" : ""}
    ${props.icon ? "padding-left:50px;" : ""}
  `}
  flex-shrink: 0;
  white-space: nowrap;
  transition: opacity 0.3s;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  outline: 0;
  .eye {
    cursor: pointer;
    padding: 5px;
  }
`;

export const TextAreaField = styled(TextField.TextArea)<{
	margin?: string;
	h?: JSX.CSSProperties["height"];
	invalid?: boolean;
	alternative?: boolean;
	disabled?: boolean;
	passwordType?: boolean;
	resize?: JSX.CSSProperties["resize"];
}>`
  width: 100%;
  ${InputDefaultCss}
  ${(props) => `
    background: ${props.alternative ? props.theme?.colors.colorInvert : props.theme?.input?.background};
    ${props.h ? `height: ${props.h};` : ""}
    color: ${props.theme?.input?.color};
    ${props.margin ? `margin: ${props.margin};` : ""}
    ${props.invalid ? `border: 2px solid ${props.theme?.colors.error}` : ""};
    ${props.disabled ? "opacity: 0.6;cursor: not-allowed;" : ""}
    ${props.passwordType ? "padding: 0 50px 0 22px;" : ""}
    ${props.resize ? `resize:${props.resize};` : ""}
  `}
  transition: opacity 0.3s;
  padding: 22px;
  overflow: auto;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  outline: 0;
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;
export const EyeWrapper = styled.div<{ clickable?: boolean }>`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: text;
  ${({ clickable }) => (clickable ? "cursor:pointer;" : "")}
  position: absolute;
  right: 10px;
  top: 50%;
  translate: 0 -50%;
`;

export const InputLabel = styled(TextField.Label)`
  font-weight: 600;
  padding: 0 0 5px 5px;
  text-align: left;
`;

export const IconWrapper = styled(EyeWrapper)`
  right: unset;
  left: 10px;
  z-index: 1;
  pointer-events: none;
`;
